import React from "react";
import ReactMarkdown from "react-markdown";

import { Parallax } from "react-scroll-parallax";

import classNames from "classnames";
import { InsideParallaxImage } from "components/Image/Index";
import * as fromProjects from "store/Projects";

import { a } from "@react-spring/web";
import { useIntersect } from "hooks/useIntersect";
import { useAnimateInTrail } from "hooks/useAnimateInTrail";
import { initialOffset } from "components/Animations/SpringProperties/SpringProperties";

interface IProps {
  animationReady: boolean;
  item: fromProjects.IContentSteppedLayoutParallaxTile;
  index: number;
}

export const ParallaxTile: React.FC<IProps> = ({
  animationReady,
  item,
  index,
  ...props
}) => {
  const evenItem: boolean = index % 2 === 0;

  const [inViewRef, inView] = useIntersect({
    startObserving: animationReady,
  });

  const [animateInTrail] = useAnimateInTrail(inView, 3);

  const descriptionStyles = {
    opacity: animateInTrail[0].active,
    transform: animateInTrail[0].active.to(
      (x) => `translateY(calc(${initialOffset(x)}))`
    ),
  };

  const mainImageStyles = {
    opacity: animateInTrail[1].active,
    transform: animateInTrail[1].active.to(
      (x) => `translateY(calc(${initialOffset(x)}))`
    ),
  };

  const blockOverlayStyles = {
    opacity: animateInTrail[2].active,
    transform: animateInTrail[2].active.to(
      (x) => `translateY(calc(${initialOffset(x)}))`
    ),
  };

  return (
    <a.div
      ref={inViewRef}
      className={classNames(
        "itemWrapper",
        { alignLeft: evenItem },
        { alignRight: !evenItem }
      )}
    >
      <div className="imageWrapper">
        <a.figure className="mainImage" style={mainImageStyles}>
          <InsideParallaxImage
            width="100%"
            heightRatio={item.image.heightRatio}
            src={"/assets/images/work/" + item.image.url}
            alt={item.image.alt}
            animateImageIn={true}
            animationType={"reveal"}
          />
        </a.figure>
        <a.div className="blockOverlay" style={blockOverlayStyles}>
          <Parallax y={["-20px", "80px"]} tagOuter="figure">
            <div
              className="parallaxInner"
              style={Object.assign(
                {},
                {
                  backgroundColor: item.overlayTileColor,
                }
              )}
            />
          </Parallax>
        </a.div>
      </div>
      <div className="titleWrapper">
        <a.div className="description" style={descriptionStyles}>
          <ReactMarkdown source={item.text} />
        </a.div>
      </div>
    </a.div>
  );
};
